// Persists the last successful search response in sessionStorage so the
// Results page survives a refresh without re-hitting the upstream provider.
// Cleared on sign-out via the auth context (`qc.clear()` evicts queries but
// not sessionStorage — we don't bother flushing here since the data is
// scoped to the current tab and contains nothing partner-secret beyond what
// the API just served the same user.).

import type { FlightSource, SearchResponse } from "./types";

export interface CachedSearch {
  // What the user typed — used to rehydrate the search bar on Results.
  form: {
    journey_type: "one_way" | "round_trip";
    origin: string;
    destination: string;
    outbound_date: string;
    inbound_date?: string;
    adult: number;
    child: number;
    infant: number;
    cabin_class: number;
    currency?: string;
    // Which provider served this search. Re-sent verbatim on a re-search so
    // the retry can't silently land on a different upstream.
    source?: FlightSource;
  };
  response: SearchResponse;
  fetched_at: number;
}

const KEY = "neptune.lastSearch";

export function saveSearch(c: CachedSearch): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(c));
  } catch {
    // Quota exceeded or storage disabled — non-fatal, we just re-fetch.
  }
}

export function loadSearch(): CachedSearch | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CachedSearch;
  } catch {
    return null;
  }
}

export function clearSearch(): void {
  sessionStorage.removeItem(KEY);
}
